<!--
 * @创建文件时间: 2019-12-21 20:36:52
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-07-03 00:11:47
 * @联系Qq:1638245306
 * @文件介绍: 附件-图片上传
 -->
<template>
  <el-dialog
    :title="isVideo ? '图片/视频' : '图片'"
    :visible.sync="fileShow"
    @close="$emit('update:dialogShow', false)"
    :show-close="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    width="30%"
  >
    <el-upload
      :ref="refName"
      :action="downUrl"
      list-type="picture-card"
      :headers="myHeaders"
      :data="params"
      :auto-upload="false"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :on-success="successHandle"
      :on-error="errorHandle"
      :before-remove="beforeRemove"
      :before-upload="beforeAvatarUpload"
      multiple
      :on-exceed="handleExceed"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <el-dialog :visible.sync="imgVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <div slot="footer">
      <el-button size="small" @click="buttonFileShow">关 闭</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="buttonLoad"
        :disabled="false"
        @click="submitUpload"
        >确 定</el-button
      >
      <!-- <el-popover placement="top-end" width="200" trigger="hover" content="功能暂时维护中...">
      <i class="el-icon-question" style="color:rgb(143, 198, 224);font-size: 1.4em;position: relative;top:5px;left:4px" slot="reference"></i>
    </el-popover> -->
    </div>
  </el-dialog>
</template>
<script>
import util from "@/libs/util.js";
export default {
  data() {
    return {
      buttonLoad: false,
      downUrl: "",
      refName: "",
      imgVisible: false,
      fileList: [],
      dialogImageUrl: "",
      fileShow: this.dialogShow,
      params: {
        path: "",
      },
      myHeaders: {},
    };
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: "",
    },
    isVideo: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogShow(val, oldVal) {
      if (val === oldVal) {
        return;
      }
      this.fileShow = val;
    },
    fileShow: function (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs[this.refName].clearFiles();
        });
      } else {
        this.$emit("successData", "");
      }
    },
  },
  methods: {
    //点击上传
    submitUpload() {
      this.buttonLoad = true;
      this.params.path = this.actionType;
      // if(this.actionType==""){
      //   this.downUrl=this.$url.uploadimages;
      // }else{
      //   this.downUrl=this.$url.uploadimages2;
      // }
      this.downUrl = this.$url.uploadimages;
      let refName = this.refName;
      this.$refs[refName].submit();
    },
    //成功后的回调
    successHandle(response, file, fileList) {
      this.fileShow = false;
      let data = response.data;
      this.$emit("successData", data);
      this.buttonLoad = false;
    },
    //失败后的回调
    errorHandle(response, file, fileList) {
      this.$emit("successData", "");
      this.buttonLoad = false;
    },
    handleRemove(file, fileList) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgVisible = true;
    },
    buttonFileShow() {
      this.$emit("successData", "");
      this.imgVisible = false;
      this.buttonLoad = false;
    },
    //验证是否是图片
    beforeAvatarUpload(file) {
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      // const isLt10M = file.size / 1024/1024 <=10//图片大小不超过2MB
      const isLt10M = true; //图片无限制
      var videomsg =
        ["video/mp4", "video/flv", "video/avi", "video/wmv", "video/rmvb"].indexOf(
          file.type
        ) >= 0;
      // const isLt100M = file.size / 1024 / 1024  <= 100;
      const isLt100M = true; //视频无限制
      if (this.isVideo) {
        if (!videomsg && !testmsg) {
          this.$message.error(
            "请上传正确的图片/视频格式！" +
              "（ 图片格式：jpeg/png/jpg，视频格式：mp4/flv/avi/wmv/rmvb ）"
          );
          this.buttonLoad = false;
          return false;
        } else {
          if (videomsg) {
            if (!isLt100M) {
              this.$message.error("上传视频大小不能超过100MB!");
              this.buttonLoad = false;
              return false;
            }
          }
          if (testmsg) {
            if (!isLt10M) {
              this.$message.error("上传图片大小不能超过 10M!");
              this.buttonLoad = false;
              return false;
            }
          }
        }
        return (testmsg && isLt10M) || (videomsg && isLt100M);
      } else {
        if (!testmsg) {
          this.$message.error("上传图片格式不对!" + "（ 图片格式：jpeg/png/jpg ）");
          this.$emit("successData", "");
          this.buttonLoad = false;
          return false;
        }
        if (!isLt10M) {
          this.$message.error("上传图片大小不能超过 10M!");
          this.$emit("successData", "");
          this.buttonLoad = false;
          return false;
        }
        return testmsg && isLt10M;
      }
    },
    //文件上传限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //删除文件
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${ file.name }？`);
      return true;
    },
    getUserToken() {
      let token = util.session.get("token");
      this.myHeaders = {
        userToken: token,
      };
    },
  },
  created() {
    this.refName = "uploadFile" + new Date().getTime();
    this.downUrl = this.$url.uploadimages;
  },
  mounted() {
    this.getUserToken();
  },
};
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/DialogImg.vue"
}
</vue-filename-injector>
